import React from "react";
import { IconProps } from "../../components/Icon";

export default function MenuIcon(props: IconProps): JSX.Element {
  const { width, height, color } = props;
  return (
    <svg
      id="More"
      xmlns="http://www.w3.org/2000/svg"
      width={width || "24"}
      height={height || "21"}
      viewBox="0 0 24 21"
    >
      <path
        id="Path_10104"
        data-name="Path 10104"
        d="M-7.018-9.783H15.268a.857.857,0,0,0,.857-.857v-2.143a.857.857,0,0,0-.857-.857H-7.018a.857.857,0,0,0-.857.857v2.143A.857.857,0,0,0-7.018-9.783Zm0,8.571H15.268a.857.857,0,0,0,.857-.857V-4.212a.857.857,0,0,0-.857-.857H-7.018a.857.857,0,0,0-.857.857v2.143A.857.857,0,0,0-7.018-1.212Zm0,8.571H15.268a.857.857,0,0,0,.857-.857V4.359a.857.857,0,0,0-.857-.857H-7.018a.857.857,0,0,0-.857.857V6.5A.857.857,0,0,0-7.018,7.359Z"
        transform="translate(7.875 13.641)"
        fill={color || "#c6cbd0"}
      />
    </svg>
  );
}
